import { FC, useMemo } from 'react'
import styles from 'components/features/pfm/LinkedAccountCategory/LinkedAccountCategory.styl'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'
import SvgIcon from 'components/atoms/SvgIcon'

type LinkedAccountCategoryProps = {
  accountInfo: MixedAccountsTableItem
  hideIcon: boolean
}
export const LinkedAccountCategory: FC<LinkedAccountCategoryProps> = (props) => {
  const { accountInfo, hideIcon } = props
  const { account, categoryName } = accountInfo

  const categoryChild = useMemo(() => {
    if (!account || !categoryName) {
      return null
    }
    return account.category === 'savings' ? categoryName : categoryName.substring(0, categoryName.length - 1)
  }, [account, categoryName])

  const iconChild = useMemo(() => {
    if (!account || !account.category || hideIcon) {
      return null
    }
    const image = require(`icons/${ account.category }.svg`).default
    if (!image) {
      return null
    }
    return (
      <div className={ styles.logoCategory }>
        <SvgIcon src={ image } />
      </div>
    )
  }, [account, hideIcon])

  if (!categoryChild) {
    return null
  }

  return (
    <div className={ styles.linkedAccountCategory }>
      { iconChild }
      { categoryChild }
    </div>
  )
}
